import * as Utils from './utils';
import { getConfig } from '@/config';
import { ModelType } from '@/constants';
export const JSON_HEADERS = { 'Content-Type': 'application/json' };
export var SearchForRetail;
(function (SearchForRetail) {
    SearchForRetail.API_URL = getConfig().ccApiUrl;
    SearchForRetail.INGEST_API_URL = getConfig().ingestApiUrl;
    SearchForRetail.SEARCH_API_URL = getConfig().searchApiUrl;
    SearchForRetail.CATEGORIES_API_URL = getConfig().categoryApiUrl;
    SearchForRetail.RECS_API_URL = getConfig().recsApiUrl;
    SearchForRetail.CONFIG_PATH = 'config';
    SearchForRetail.ADMIN_PATH = 'admin';
    SearchForRetail.AREA_PATH = `${SearchForRetail.ADMIN_PATH}/area`;
    SearchForRetail.USER_PATH = 'user';
    SearchForRetail.PERMISSION_ROLE_PATH = `${SearchForRetail.USER_PATH}/roles`;
    SearchForRetail.TAG_PATH = `${SearchForRetail.ADMIN_PATH}/tag`;
    SearchForRetail.LOGIN_PATH = 'login';
    SearchForRetail.AUTH_VALIDATION_PATH = 'oauth/access_token';
    SearchForRetail.TENANT_PATH = 'tenant';
    SearchForRetail.SETTINGS_PATH = 'settings';
    SearchForRetail.AUDIT_LOG_PATH = 'audit-log';
    SearchForRetail.ZONE_PATH = 'zone';
    SearchForRetail.PROMOTE_PATH = 'promote';
    SearchForRetail.PROMOTION_PATH = 'promotion';
    SearchForRetail.ANALYTICS_PATH = 'analytics';
    SearchForRetail.RELEASE_NOTES_PATH = 'release-notes/storage';
})(SearchForRetail || (SearchForRetail = {}));
const SEO_MANAGER_API_URL = getConfig().seoManagerApiUrl;
export const seoUrls = new Map([
    ['sitemap', `${SEO_MANAGER_API_URL}/sitemaps`],
    ['keywords', `${SEO_MANAGER_API_URL}/keywords`],
]);
export function s4rPermissionRole() {
    return {
        find: Utils.authenticated(s4rFindPermissionRoles),
    };
}
export function s4rValidate(refreshToken) {
    return {
        url: `${SearchForRetail.API_URL}/${SearchForRetail.AUTH_VALIDATION_PATH}`,
        headers: Object.assign(Object.assign({}, JSON_HEADERS), Utils.buildCustomerHeaders()),
        expiry: false,
        skipCache: true,
        body: {
            'refresh_token': refreshToken,
            'grant_type': 'refresh_token',
        },
        method: 'POST',
    };
}
export function s4rFindPermissionRoles() {
    return s4rFind(SearchForRetail.PERMISSION_ROLE_PATH);
}
export function auth() {
    return {
        s4rValidate: Utils.authenticated(s4rValidate),
        searchForRetail: {
            [ModelType.PERMISSION_ROLE]: s4rPermissionRole(),
        },
    };
}
export default { auth };
export function s4rFind(path, parse, skipCache) {
    return {
        parse,
        skipCache,
        url: `${SearchForRetail.API_URL}/${path}`,
        headers: Utils.buildCustomerHeaders(),
    };
}
